import { parseSeoMetaField } from './parseSeoMeta'
import { seoState } from './seoState'

function canonicalHref() {
  if (typeof window === 'undefined') return ''
  const path = window.location.pathname || '/'
  const hash = window.location.hash && window.location.hash !== '#' ? window.location.hash : ''
  const pathname = path.length > 1 ? path.replace(/\/+$/, '') : '/'
  return `${window.location.origin}${pathname === '/' ? '/' : pathname}${hash}`
}

/** Подмешивает SEO бренда в metaInfo. Пустые поля уже дополнены записью type=default на API. */
export function metaFromSeo(defaults = {}) {
  const seo = seoState.page
  const parsed = parseSeoMetaField(seo && seo.meta)
  const description = String((parsed.description || defaults.description || '')).trim()
  const keywords = String(
    (seo && seo.request && String(seo.request).trim())
    || defaults.keywords
    || defaults.meta
    || '',
  ).trim()
  const meta = []

  if (description) {
    meta.push({ vmid: 'description', name: 'description', content: description })
    meta.push({ vmid: 'og:description', property: 'og:description', content: description })
  }
  if (keywords) {
    meta.push({ vmid: 'keywords', name: 'keywords', content: keywords })
  }
  meta.push({ vmid: 'robots', name: 'robots', content: 'index, follow' })

  if (parsed.appleMobileWebAppTitle) {
    meta.push({ vmid: 'apple-mobile-web-app-title', name: 'apple-mobile-web-app-title', content: parsed.appleMobileWebAppTitle })
  }
  if (parsed.applicationName) {
    meta.push({ vmid: 'application-name', name: 'application-name', content: parsed.applicationName })
  }
  if (parsed.msapplicationTileColor) {
    meta.push({ vmid: 'msapplication-TileColor', name: 'msapplication-TileColor', content: parsed.msapplicationTileColor })
  }
  if (parsed.themeColor) {
    meta.push({ vmid: 'theme-color', name: 'theme-color', content: parsed.themeColor })
  }

  const links = []
  const canonical = canonicalHref()
  if (canonical) {
    links.push({ vmid: 'canonical', rel: 'canonical', href: canonical })
    meta.push({ vmid: 'og:url', property: 'og:url', content: canonical })
  }

  const title = seo && seo.title ? String(seo.title).trim() : ''
  if (title) {
    meta.push({ vmid: 'og:title', property: 'og:title', content: title })
    return {
      title,
      titleTemplate: '%s',
      meta,
      link: links,
    }
  }

  return {
    title: defaults.title,
    titleTemplate: defaults.titleTemplate,
    meta,
    link: links,
  }
}
